export const INVALID_IMAGE_BOUNDS = 12;
export const INVALID_IMAGE_MIME_TYPE = 13;
export const LIKE_ALREADY_EXISTS_ERR_CODE = 14;
export const LIKE_NOT_AUTHORISED_ERR_CODE = 15;
export const LIKES_LIMIT_REACHED = 22;
